import { type Country } from '@backmarket/http-api'

import { getAllStates } from './getAllStates'

export function getShippingStates(country: Country) {
  return getAllStates(country).filter((state) => !state.forbidShipping)
}
